import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const StyledLink = styled(Link)`
    color: inherit;
    text-decoration: none;
    
`

export default (props) => <StyledLink {...props}/>